import { addLeadingZero, asCommaedInteger } from "../../utils/humanize";

export const convertToShiftDate = (date?: string): string => {
    if (!date) {
        return "";
    }
    const _d = date.split("-").join("/");
    return _d;
};

export const convertRequestMonth = (date: string): number => {
    const _d = date.split("-").join("");
    return parseInt(_d, 10);
};

export const convertToMonthDay = (date?: string): string => {
    if (!date) {
        return "";
    }
    const _d = date.split("-");
    const _month = _d[1];
    const _day = _d[2];
    return `${_month}/${_day}`;
};

export const formatPaymentAmountDisplay = (
    rate?: number,
    includeYenSign = false
): string => {
    if (rate == 0) {
        if (includeYenSign) {
            return "0円";
        }
        return "0";
    }
    if (!rate) {
        return "";
    }

    const base_display = asCommaedInteger(Math.floor(rate));

    if (includeYenSign) {
        return `${base_display}円`;
    }
    return base_display;
};

export const formatFloatToPercentage = (rate?: number, digit = 1): string => {
    if (!rate) {
        return "";
    }
    return (rate * 100).toFixed(digit) + "%";
};

export const convertFloatToPercentage = (rate?: number): string => {
    if (rate == 0) {
        return "0%";
    }
    if (!rate) {
        return "";
    }
    if (rate > 0.9999) {
        return "100%";
    }
    return `${Math.floor(rate * 100)}%`;
};

export const convertMinToDisplayFormat = (min?: number): string => {
    if (min == 0) {
        return "0分";
    }
    if (!min) {
        return "";
    }
    const hrs = Math.floor(min / 60);
    const mins = addLeadingZero(min % 60);

    if (hrs == 0) {
        return `${mins}分`;
    }

    return `${hrs}時間${mins}分`;
};

const GUIDANCE_REQUIRED_PHRASE = "required";
const GUIDANCE_UNNECCESSARY_PHRASE = "unnecessary";

export const convertNeedGuidanceToCheckMark = (
    needGuidance?: string
): string => {
    if (!needGuidance) {
        return " ";
    }
    if (needGuidance === GUIDANCE_REQUIRED_PHRASE) {
        return "✔️";
    }
    return " ";
};

export const convertNeedGuidanceToBatsuMark = (
    needGuidance?: string
): string => {
    if (!needGuidance) {
        return "";
    }
    if (needGuidance === GUIDANCE_REQUIRED_PHRASE) {
        return "❌";
    }
    return "";
};

export const secToMinSec = (sec?: number): string => {
    if (sec == 0) {
        return "0秒";
    }
    if (!sec) {
        return "";
    }
    const min = Math.floor(sec / 60);
    const _s = sec % 60;

    return `${addLeadingZero(min)}分${addLeadingZero(_s)}秒`;
};

export const toStr = (val?: string | null): string => {
    return val ? val : "";
};

export const toNum = (val?: number | null): number => {
    return val ? val : 0;
};
